import React, { useState, useEffect } from 'react';
import './App.css';
import CompanyCard from './components/CompanyCard';
import ProductCard from './components/ProductCard';
import SearchBar from './components/SearchBar';
import SearchResults from './components/SearchResults';
import Pagination from './components/Pagination';
import companiesData from './data/companies.json';
import { searchCompanies, getSearchResultCounts } from './utils/searchUtils';

function App() {
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    // Simulate loading data from JSON file
    setTimeout(() => {
      setItems(companiesData.items);
      setFilteredItems(companiesData.items);
      setLoading(false);
    }, 500);
  }, []);

  // Handle search
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1); // Reset to first page when searching
    const filtered = searchCompanies(items, term);
    setFilteredItems(filtered);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top of results
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Get paginated items
  const getPaginatedItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredItems.slice(startIndex, endIndex);
  };

  // Get search result counts
  const searchResultCounts = getSearchResultCounts(filteredItems, searchTerm);
  const totalCounts = getSearchResultCounts(items, '');
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  if (loading) {
    return (
      <div className="app">
        <div className="loading">
          <div className="spinner"></div>
          <p>កំពុងផ្ទុកក្រុមហ៊ុន...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>Don't Thai to Me</h1>
        <p>ទិញទំនិញថៃស្មើនិងអោយលុយថៃទិញអាវុធមកសម្លាប់ខ្មែរ។</p>
      </header>
      
      <main className="app-main">
        {/* Search Bar */}
        <SearchBar onSearch={handleSearch} />
        
        {/* Search Results Summary */}
        <SearchResults 
          searchTerm={searchTerm}
          resultCounts={searchResultCounts}
          totalCounts={totalCounts}
        />
        
        {/* Items Grid */}
        <div className="items-grid">
          {getPaginatedItems().map(item => (
            <div key={item.id}>
              {item.type === 'company' ? (
                <CompanyCard company={item} searchTerm={searchTerm} />
              ) : (
                <ProductCard product={item} searchTerm={searchTerm} />
              )}
            </div>
          ))}
        </div>
        
        {/* No results message */}
        {filteredItems.length === 0 && searchTerm && (
          <div className="no-companies-found">
            <p>រកមិនឃើញក្រុមហ៊ុនណាដែលត្រូវនឹងលក្ខខណ្ឌស្វែងរករបស់អ្នកទេ។</p>
            <p>សូមព្យាយាមកែប្រែពាក្យស្វែងរក ឬរុករកក្រុមហ៊ុនទាំងអស់។</p>
          </div>
        )}
        
        {/* Pagination */}
        {filteredItems.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalItems={filteredItems.length}
            itemsPerPage={itemsPerPage}
          />
        )}
      </main>
    </div>
  );
}

export default App;
